module.exports = __webpack_public_path__ + "img/SCBPT_CircleOnly.ff6d246c.png";